export default {
  ACTIONS (state, value) {
    state.actions = value
  },
  MODELS (state, value) {
    state.models = value
  },
  LIST (state, value) {
    state.list = value || []
  }
}
